/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RelatedIncidentReportDtoFromJSON, RelatedIncidentReportDtoToJSON, } from './RelatedIncidentReportDto';
/**
 * Check if a given object implements the RelatedFootageResponse interface.
 */
export function instanceOfRelatedFootageResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function RelatedFootageResponseFromJSON(json) {
    return RelatedFootageResponseFromJSONTyped(json, false);
}
export function RelatedFootageResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(RelatedIncidentReportDtoFromJSON)),
    };
}
export function RelatedFootageResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(RelatedIncidentReportDtoToJSON)),
    };
}
